export const EMBED_TRANSCRIPT_EDITOR_CONTEXT_PARAM_NAME = 'context';
export const EMBED_TRANSCRIPT_EDITOR_MARGIN_PARAM_NAME = 'margin';
export const EMBED_TRANSCRIPT_EDITOR_START_MILLIS_PARAM_NAME = 'startMillis';
export const EMBED_TRANSCRIPT_EDITOR_END_MILLIS_PARAM_NAME = 'endMillis';
export const EMBED_TRANSCRIPT_EDITOR_AUDIO_ENABLED_PARAM_NAME = 'audioEnabled';
